import React, { useEffect, useRef, useState } from 'react';
import { photoUrl, LEGAL } from '../siteData';

// ── Tiny client-side navigation (no router package) ─────────────
export function navigate(path) {
  if (window.location.pathname + window.location.search === path) return;
  window.history.pushState({}, '', path);
  window.dispatchEvent(new Event('soch:navigate'));
  window.scrollTo(0, 0);
}

export function Link({ to, children, ...rest }) {
  const onClick = (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(to);
  };
  return <a href={to} onClick={onClick} {...rest}>{children}</a>;
}

const reduced = () => typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// ── The stage: a sticky photo that follows the reading ──────────
// photos: { key: [file, title, line] }; activeKey: which entry shows now.
export function Stage({ photos, activeKey, wordmarkTo = "/", wordmark = true }) {
  const entry = photos[activeKey] || photos[Object.keys(photos)[0]];
  const files = [...new Set(Object.values(photos).map((p) => p[0]))];
  const [cap, setCap] = useState({ title: entry[1], line: entry[2] });
  const [swap, setSwap] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) { first.current = false; return undefined; }
    setSwap(true);
    const t = setTimeout(() => { setCap({ title: entry[1], line: entry[2] }); setSwap(false); }, reduced() ? 0 : 260);
    return () => clearTimeout(t);
  }, [entry[1], entry[2]]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <aside className="stage" aria-label="Soch garments">
      {files.map((f, i) => (
        <img key={f} src={photoUrl(f)} alt="" decoding="async" loading={f === entry[0] || i === 0 ? 'eager' : 'lazy'}
          className={f === entry[0] ? 'on' : ''} />
      ))}
      {wordmark && <Link className="wordmark" to={wordmarkTo}>Soch</Link>}
      <div className="scrim" />
      {/* Only the garment's name, like a catalogue caption: the team name is already the heading beside it. */}
      <div className={`cap ${swap ? 'swap' : ''}`}>
        {cap.line && <span>{cap.line}</span>}
      </div>
    </aside>
  );
}

export function SiteFooter({ children }) {
  return (
    <footer className="site-foot">
      <b>Soch</b>
      <p>Ethnic wear for women, with stores across India. Visit <a href="https://www.soch.com" target="_blank" rel="noopener noreferrer">soch.com</a> to see the clothes.</p>
      {children}
      <p className="legal">
        <a href={LEGAL.privacy} target="_blank" rel="noopener noreferrer">Privacy policy</a>
        <a href={LEGAL.terms} target="_blank" rel="noopener noreferrer">Terms and conditions</a>
      </p>
    </footer>
  );
}
